const SAFE_PROTOCOLS = ['http:', 'https:', 'ftp:', 'ftps:', 'mailto:'];

export const getIsSafeUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);

    const { protocol } = urlObj;

    if (SAFE_PROTOCOLS.includes(protocol)) {
      return true;
    }
  } catch (error) {
    // Intentionally empty catch block - just return false below.
  }

  return false;
};
